import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { Portal } from "react-portal";

import { Container, Text } from "./styles";

export type SnackbarType = "Alert" | "Info" | "Warning";

export enum SnackbarTypeValues {
  ALERT = "Alert",
  INFO = "Info",
  WARNING = "Warning",
}

type Props = {
  onClose: () => void;
  message?: string;
  timer?: number;
  type?: SnackbarType;
  position?: "top" | "bottom";
};

const DEFAULT_TIMER = 6000;

const Snackbar: React.FC<Props> = ({
  onClose,
  message,
  timer = DEFAULT_TIMER,
  type = SnackbarTypeValues.INFO,
  position = "bottom",
}) => {
  const lastTimerId = useRef<number | null>(null);

  useEffect(() => {
    if (lastTimerId.current) {
      clearTimeout(lastTimerId.current);
      lastTimerId.current = null;
    }

    if (message) {
      lastTimerId.current = window.setTimeout(onClose, timer);
    }

    return () => {
      if (lastTimerId.current) {
        clearTimeout(lastTimerId.current);
        lastTimerId.current = null;
      }
    };
  }, [message, timer, onClose]);

  if (!message) return null;

  return (
    <Portal>
      <Container position={position} type={type}>
        <Text>{message}</Text>
      </Container>
    </Portal>
  );
};

export default observer(Snackbar);
